<template>
    <div>
     <h2>Filters</h2>
    <div v-if="max !=0">
        <vs-button color="danger" @click="addFilter">Add Family Filter</vs-button>
        <vs-button color="green" @click="addSkip" class="ml-2">Add Skip</vs-button>
        <div style="height: 500px;overflow-x: auto;">
            <div v-for="(filt,index) in skips" :key="'s'+index" class="m-4 card shadow p-3">
              <vs-button radius color="danger" type="filled" icon="delete" size="small" @click="skips.splice(index,1)"></vs-button>
            <span>start:{{new Date(filt[0] * 1000).toISOString().substr(11, 8)}} | end:{{new Date(filt[1] * 1000).toISOString().substr(11, 8)}}</span>
            <div class="flex">
              <vs-input size="small" class="m-1" v-model="filt[0]" />
              <vs-input size="small" class="m-1" v-model="filt[1]" />  
            </div>
            <vs-slider color="green" text-fixed=sec ticks :max="max" v-model="skips[index]" />
        </div>
        <div v-for="(filt,index) in filters" :key="index" class="m-4 card p-3">
            <vs-button radius color="danger" type="filled" icon="delete" size="small" @click="filters.splice(index,1)"></vs-button>
            <span>start:{{new Date(filt[0] * 1000).toISOString().substr(11, 8)}} | end:{{new Date(filt[1] * 1000).toISOString().substr(11, 8)}}</span>
            <div class="flex">
              <vs-input size="small" class="m-1" v-model="filt[0]" />
              <vs-input size="small" class="m-1" v-model="filt[1]" />  
            </div>            
            <vs-slider color="danger" text-fixed=sec ticks :max="max" v-model="filters[index]" />
        </div>
        </div>
     
        <vs-button color="warning" @click="saveFilters">Save Filters</vs-button>
    </div>

    
        

    </div>
</template>
<script>
     export default {
        props: ['movie','duration','position'],
        data() {
            return {
                max:0,
                filters: [],
                skips: [],
            }
        },
       created() {
                this.max=this.duration;
                if (this.movie && this.movie.length !=0) {
                    this.movie.response.filters.forEach(element => {
                        if (element.type==0) {
                            for (let index = 0; index < element.data.length; index++) {
                                const filter = element.data[index];
                               this.filters.push(filter)
                            }
                           
                           
                        }else{
                            for (let index = 0; index < element.data.length; index++) {
                                const filter = element.data[index];
                               this.skips.push(filter)
                            }
                        }
                    });
                }
            },
        methods: {
            addFilter() {
                 if (this.filters.length !=0) {
                   var currentTime=this.filters[this.filters.length-1];
                  this.filters.push([currentTime[1]+10, currentTime[1]+40,currentTime[1]+80]);  
                }else{
                 var currentTime=this.filters[this.filters.length-1];
                  this.filters.push([1,20]); 
                }
            },
            getFilters(){

            },
            
            addSkip() {
                var current=this.position;
                 if (this.skips.length !=0) {
                   var currentTime=this.skips[this.skips.length-1];
                  this.skips.push([current,current+10]);  
                }else{
                    
                 this.skips.push([0,current]);
                }
  
            },

            saveFilters(){
                const data=new FormData();
                data.append('filters',JSON.stringify(this.filters));
                data.append('skips',JSON.stringify(this.skips));
                data.append('movie',this.movie.response.id);
                this.axios.post(`${this.$apiUrl}/movies/filters`,data).then(res=>{
                     this.$vs.notify({
                            color: 'primary',
                            title: 'Filters Updated',
                            text: '',
                            position: 'bottom-right'
                        })
                    this.getFilters();
                })
            }

        }, 
    }
</script>
